import { computed, readonly, ref } from "vue";
import api from "@/api";

export interface IUserNotificationAction {
    type: 'download';
    label: string;
    url: string;
    fileName: string;
}

export interface IUserNotification {
    key: string;
    title: string;
    message: string;
    action: IUserNotificationAction | null;
    isRead: boolean;
    readAt: string | null;
}

const items = ref<IUserNotification[]>([]);
const loading = ref(false);

const unreadCount = computed(() => items.value.filter((item) => !item.isRead).length);

async function fetchNotifications(): Promise<void> {
    if (loading.value) {
        return;
    }
    loading.value = true;
    try {
        const r: any = await api.v1.notifications.index();
        items.value = Array.isArray(r?.data?.data?.items) ? r.data.data.items : [];
    } catch {
        items.value = [];
    } finally {
        loading.value = false;
    }
}

async function markRead(key: string): Promise<void> {
    const item = items.value.find((n) => n.key === key);
    if (!item || item.isRead) {
        return;
    }

    item.isRead = true;
    try {
        const r: any = await api.v1.notifications.markRead(key);
        item.readAt = r?.data?.data?.readAt ?? new Date().toISOString();
    } catch {
        item.isRead = false;
    }
}

async function markAllRead(): Promise<void> {
    const unreadKeys = items.value.filter((n) => !n.isRead).map((n) => n.key);
    await Promise.all(unreadKeys.map((key) => markRead(key)));
}

export function userNotificationsStore() {
    return {
        items: readonly(items),
        unreadCount,
        fetchNotifications,
        markAllRead,
    };
}
